import ReactDOM from 'react-dom';

export const Portal: React.FC<{open: boolean; portalTarget?: HTMLElement}> = (props) => {
  if (!props.open) return null;
  return ReactDOM.createPortal(props.children, props.portalTarget || document.body);
};
